import React from 'react';
import ReactSelect from '../ReactSelect';

export const assemblyTypes = [
  'RP',
  'RPDA',
  'RPDA_2',
  'DC',
  'DCDA',
  'DCDA_2',
  'TYPE_2_BYPASS',
  'PVB',
  'SVB',
  'AVB',
  'AIR_GAP',
] as const;

export type AssemblyType = (typeof assemblyTypes)[number];

const typeOptions = assemblyTypes.map((type) => ({
  value: type,
  label: type.replace(/_/g, ' '),
}));

export const AssemblyTypePicker = ({
  value,
  isClearable,
  isDisabled,
  onChange,
  placeholder = '',
}: {
  value?: AssemblyType;
  isClearable?: boolean;
  isDisabled?: boolean;
  onChange: (value?: AssemblyType) => void;
  placeholder?: string;
}) => (
  <ReactSelect
    placeholder={placeholder}
    isClearable={isClearable}
    isDisabled={isDisabled}
    value={typeOptions.find((option) => value === option.value)}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={typeOptions}
  />
);
